import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { IconButton, Tooltip } from '@mui/material'
import Inquiry from 'app/EgretLayout/SharedCompoents/Inquiry'
import { HELP_CASE_TYPES } from 'app/services/sfAuth/sfData/sfCaseTypes'
import React, { useState } from 'react'

const HelpIconButton: React.FC<{ caseType: string }> = ({ caseType }) => {
  const [inquiryOpen, setInquiryOpen] = useState<boolean>(false)

  const handleClick = () => {
    setInquiryOpen(true)
  }

  return (
    <>
      <Tooltip title='Help'>
        <span><IconButton color='primary' onClick={handleClick}>
          <HelpOutlineOutlinedIcon />
        </IconButton></span>
      </Tooltip>
      <Inquiry
        selectCaseType={caseType === HELP_CASE_TYPES.CONTACT_US}
        open={inquiryOpen}
        handleClose={() => {
          setInquiryOpen(false)
        }}
        caseType={caseType}
      />
    </>
  )
}

export default HelpIconButton
